import { HeadCell } from 'components/list/list';
import { IntlShape } from 'react-intl';

const PAGE_NAME_ID = 'orderFeed.listOrderSupplyPlan';

/**
 * Renders the Sites Overview list options in Order Feed
 * @param isChile #TODO: Remove after chile testing in playground is done. This bool hides certain columns in Order Feed
 * @returns
 */
export const SiteListColumns = (intl: IntlShape, hasOrderFreeDelivery2: boolean) => {
  const inactiveSitesColumns: HeadCell[] = [
    {
      id: 'siteName',
      label: intl.formatMessage({ id: `${PAGE_NAME_ID}.siteList.siteNameLabel` }),
    },
    { id: 'actions', label: '', align: 'left', autoWidth: true },
  ];

  const noOrderFreeDeliveryColumns: HeadCell[] = [
    { id: 'siteName', label: intl.formatMessage({ id: `${PAGE_NAME_ID}.siteList.siteNameLabel` }) },
    { id: 'actions', label: '', align: 'left', autoWidth: true },
  ];

  const activeSitesColumns: HeadCell[] = [
    { id: 'siteName', label: intl.formatMessage({ id: `${PAGE_NAME_ID}.siteList.siteNameLabel` }) },
    { id: 'alert', label: '' },
    { id: 'ofd', label: intl.formatMessage({ id: `${PAGE_NAME_ID}.siteList.ofdLabel` }), align: 'center' },
    {
      id: 'inventory',
      label: intl.formatMessage({ id: `${PAGE_NAME_ID}.siteList.inventoryLabel` }),
      align: 'center',
      hide: !hasOrderFreeDelivery2,
    },
    {
      id: 'weeklyConsumption',
      label: intl.formatMessage({ id: `${PAGE_NAME_ID}.siteList.weekConsumptionLabel` }),
      align: 'center',
    },
    {
      id: 'supplyWeek',
      sortLabelProps: { hideSortIcon: true, disabled: true },
      label: intl.formatMessage({ id: `${PAGE_NAME_ID}.siteList.supplyWeekLabel` }, { weekValue: 1 }),
    },
    {
      id: 'supplyWeek2',
      sortLabelProps: { hideSortIcon: true, disabled: true },
      label: intl.formatMessage({ id: `${PAGE_NAME_ID}.siteList.supplyWeekLabel` }, { weekValue: 2 }),
    },
    {
      id: 'supplyWeek3',
      sortLabelProps: { hideSortIcon: true, disabled: true },
      label: intl.formatMessage({ id: `${PAGE_NAME_ID}.siteList.supplyWeekLabel` }, { weekValue: 3 }),
    },
    {
      id: 'siteIntensity',
      label: intl.formatMessage({ id: `${PAGE_NAME_ID}.siteList.siteIntensityLabel` }),
      align: 'center',
    },
    { id: 'actions', label: '', align: 'left', autoWidth: true },
  ];

  const isFetchingSitesColumns: HeadCell[] = [
    { id: 'siteName', label: intl.formatMessage({ id: `${PAGE_NAME_ID}.siteList.siteNameLabel` }), sx: { width: 200 } },
    {
      id: 'ofd',
      label: intl.formatMessage({ id: `${PAGE_NAME_ID}.siteList.ofdLabel` }),
      align: 'center',
      sx: { width: 100 },
    },
    { id: 'actions', label: '', align: 'left', autoWidth: true },
  ];

  return { inactiveSitesColumns, noOrderFreeDeliveryColumns, activeSitesColumns, isFetchingSitesColumns };
};
